import moment from 'moment';

const URL_START = 'https://blog-backend.azurewebsites.net/';

export const getPostById = async ({_id}) => {    
    let post = await (await fetch(`${URL_START}post/${_id}`)).json();
    post.createdAt = moment(post.createdAt).calendar();

    return post;
};

export const editPostById = async ({ _id, title, content, accessToken }) => {
    await fetch(`${URL_START}post/${_id}`, {
        method: 'PATCH', mode: 'cors', headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken,
        }, body: JSON.stringify({ title, content })
    });
};

export const deletePostById = async ({ accessToken, _id }) => {
    await fetch(`${URL_START}post/${_id}`, {
        method: 'DELETE', mode: 'cors', headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken,
        }
    });
};

export const getPosts = async () => {
    let posts = await (await fetch(`${URL_START}post/`)).json();
    
    posts = posts.map(post => {
        const readableDate = moment(post.createdAt).calendar();
        
        return {...post, createdAt: readableDate} 
    });
    return posts;
};

export const sendPost = async ({accessToken, title, content}) => {
    await fetch(`${URL_START}post/`, {
        method: 'POST', mode: 'cors', headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken,
        }, body: JSON.stringify({title, content})});
};

export const login = async ({username, password}) => {
    const response = await fetch(`${URL_START}users/login`, {
        method: 'POST', mode: 'cors', headers: {
            'Content-Type': 'application/json'
        }, body: JSON.stringify({ username, password })
    });

    if(response.status == 200)
        return await response.json();
    else
        throw Error('Could not login.');
}